import React, { Suspense, lazy } from 'react'
import { Route, Routes } from 'react-router-dom'
import ProtectedRoute from './ProtectedRoute'
import NotFound from '../pages/404/NotFound'
import Login from '../pages/Auth/login'
import MsalRedirect from '../pages/Auth/MsalRedirect'

const DashboardContent = lazy(() => import('../Components/DashboardContent'))
const DashboardScreensLayout = lazy(() => import('../Components/DashboardScreensLayout'))
const ClaimListTable = lazy(() => import('../pages/claim/ClaimListTable'))
const ClaimScreenForDashboard = lazy(() => import('../pages/claim/ClaimScreenForDashboard'))
const ClaimDetail = lazy(() => import('../pages/claim/details'))
const SalesDetail = lazy(() => import('../pages/Sales/SalesScreenForDashboard'))
const PaymentDetails = lazy(() => import('../pages/Payment/PaymentScreenForDashboard'))
const Upload = lazy(() => import('../pages/Sales/SalesUpload'))
const PaymentCancellationsUpload = lazy(
  () => import('../pages/Payment/PaymentCancellataionsUpload'),
)
const ViewSales = lazy(() => import('../pages/Sales/ViewSales'))
const SIngleSaleFile = lazy(() => import('../pages/Sales/SingleSaleFileUpload'))
const ViewAllContract = lazy(() => import('../pages/Sales/ViewAllContracts'))
const ViewContract = lazy(() => import('../pages/ViewContract/ViewContract'))

const AppRoutes = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path='/login' element={<Login />} />

        <Route path='/redirect' element={<MsalRedirect />} />

        <Route
          path='/'
          element={
            <ProtectedRoute>
              <DashboardContent />
            </ProtectedRoute>
          }
        />

        <Route
          element={
            <ProtectedRoute>
              <DashboardScreensLayout />
            </ProtectedRoute>
          }
        >
          <Route path='serviceorder'>
            <Route path='' element={<ClaimScreenForDashboard />} />
            <Route path='list' element={<ClaimListTable />} />

            <Route path='list/:id' element={<ClaimDetail />} />
          </Route>

          <Route path='sales'>
            <Route path='' element={<SalesDetail />} />
            <Route path='upload' element={<Upload />} />
            <Route path='viewSales' element={<ViewSales />} />
            <Route path='uploadSingleSale' element={<SIngleSaleFile />} />
            <Route path='uploadSingleSale/:dealerSalesId?' element={<SIngleSaleFile />} />
            <Route path='viewAllContract' element={<ViewAllContract />} />
            <Route path='viewContract' element={<ViewContract />} />
          </Route>

          <Route path='payment'>
            <Route path='' element={<PaymentDetails />} />
            <Route path='process-cancellations' element={<PaymentCancellationsUpload />} />
          </Route>
        </Route>

        <Route path='*' element={<NotFound />} />
      </Routes>
    </Suspense>
  )
}

export default AppRoutes
